import { IAnalyticsEventUser } from './types';

export const userLoggedInSuccessfully = (): IAnalyticsEventUser => ({
  eventName: 'User Logged In Successful',
});
